// #region Imports
//Components    
import { defineComponent } from "vue";
import { DxCheckBox } from 'devextreme-vue/check-box';
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-checkbox-field',
    mixins: [host.mixins.form],
    // #endregion
    // #region Components
    components: {
        DxCheckBox
    },
    // #endregion
    // #region Props
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
    },
    computed: {
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    // #endregion
});
// #endregion
